const OWNER_EMAIL = "jaytoe.tukanu@outlook.com";

export function canSeeMPress(user) {
  if (!user) return true;
  if (String(user.email || "").trim().toLowerCase() === OWNER_EMAIL) return true;
  return user.role === "client";
}